/* Info component on the Callsheet page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";
import { useCurrentUser } from '../../../contexts/CurrentUserContext';

const InfoCall = () => {
  const currentUser = useCurrentUser();
  return (
    <div>
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
        <h5 className={`text-center pb-2 ${styles.Red }`} >CALLSHEEET INFO</h5>
        <hr className={`mt-2 mb-0`}/>
        {/* Superadmin */}
        {currentUser &&
                currentUser?.groups.length > 0 &&
                (currentUser?.groups[0]?.name === "Superadmin") ? (
                    <div>  
                    <p>GENERAL INFO
                    </p>
                    <p className="pt-2"> <span className={`${styles.Red}`}>* Important!</span> When you receive an email
                    with the Callsheet Link and open the Callsheet for the first time click 
                    the <span className={`${styles.Red}`}>Received</span> button, 
                    on the top of the Callsheet, to confirm receipt.
                    </p>
                    <p className="pt-2"> <span className={`${styles.Red}`}>*</span> Your <span className={`${styles.Red}`}>Personal Calltime</span> displays 
                    in the Your Call box.
                    </p>
                    <p className='pt-5'>CREATE/EDIT & SEND/RECEIVED INFO
                    </p>
                    <p className="pt-2">
                    <span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}> Edit</span> button 
                    here to open the Callsheet Add/Edit page, which contains an info tab containing the necessary instructions.
                    </p>
                    <p className="pt-2">
                    <span className={`${styles.Red}`}>*</span> When the Callsheet is finalised use the <span className={`${styles.Red}`}>SEND EMAILS</span> button to send a link to 
                    the Callsheet page using an Email List comprised of the emails of all the Callsheet Crew and the Cast 
                    called for that Day.
                    </p>
                    <p className="pt-2">
                    <span className={`${styles.Red}`}>*</span> The <span className={`${styles.Red}`}>Email List</span> can be copied at any stage and 
                    used on other email services, see the Send page for more info.
                    </p>
                    <p className="pt-2"> <span className={`${styles.Red}`}>*</span> Click the <span className={`${styles.Red}`}>RECEIVED PAGE</span> button to open the Received page which displays all Cast and Crew 
                    members from the Email List and a "Received" or "Not Received" box.
                    </p>
                    <p className={`pt-3 ${styles.Small}`}>
                    <span className={`${styles.Red}`}>*</span> Users who are assigned to work on the Callsheet need to be given 
                    the <span className={`${styles.Red}`}>Superadmin Permission</span>.
                    </p>
                    <p className={`${styles.Small} pt-2`}>
                    <span className={`${styles.Red}`}>*</span> Important! Superadmins not assigned to work on the Callsheet should not 
                    create, edit or delete Callsheets or use the Send button.
                    </p>
                    </div>
                  ) : (
                    <div>  
                    <p className="pt-2"> <span className={`${styles.Red}`}>* Important!</span> When you receive an email
                    with the Callsheet Link and open the Callsheet for the first time click 
                    the <span className={`${styles.Red}`}>Received</span> button, 
                    on the top of the Callsheet, to confirm receipt.
                    </p>
                    <p className="pt-2"> <span className={`${styles.Red}`}>*</span> Your <span className={`${styles.Red}`}>Personal Calltime</span> displays 
                    in the Your Call box.
                    </p>
                </div>
            )}
            <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoCall